module.exports = require("@embedpdf/plugin-selection/react");